document.addEventListener("DOMContentLoaded", function () {
  // ---- Tabs ----
  const tabLinks = document.querySelectorAll('.tab-link');
  if (tabLinks.length) {
    tabLinks.forEach(function (tab) {
      tab.addEventListener('click', function () {
        document.querySelectorAll('.tab-link').forEach(function (item) {
          item.classList.remove('current');
        });
        document.querySelectorAll('.tab-content > div').forEach(function (content) {
          content.classList.remove('current');
        });

        const tabId = this.getAttribute('data-tab');
        this.classList.add('current');
        const target = document.getElementById(tabId);
        if (target) target.classList.add('current');
      });
    });
  }

  // ---- Switch ----
  const switchInput = document.querySelector('.switch input');
  if (switchInput) {
    switchInput.addEventListener('change', function () {
      const isChecked = this.checked;

      document.querySelectorAll('.switcher_unit .units').forEach(function (item) {
        item.classList.remove('current');
      });
      document.querySelectorAll('.size_table').forEach(function (table) {
        table.classList.remove('current');
      });

      if (isChecked) {
        document.querySelector('.units[data-tab="in"]')?.classList.add('current');
        document.querySelector('.size_table[data-tab="in"]')?.classList.add('current');
      } else {
        document.querySelector('.units[data-tab="cm"]')?.classList.add('current');
        document.querySelector('.size_table[data-tab="cm"]')?.classList.add('current');
      }
    });

    // Trigger initial state safely
    switchInput.dispatchEvent(new Event('change'));
  }
});
